(function () {
  var _footerVisible = false;
  var _trigger = null;

  function setBodySticky(active) {
    if (_footerVisible && active) return;
    document.body.classList.toggle('notice-sticky-active', active);
    var desktopBar = document.querySelector('.desktop-sticky-add-to-cart');
    if (desktopBar) {
      if (active && window.matchMedia('(min-width: 768px)').matches) {
        desktopBar.style.display = 'flex';
        desktopBar.setAttribute('aria-hidden', 'false');
      } else {
        desktopBar.style.display = 'none';
        desktopBar.setAttribute('aria-hidden', 'true');
      }
    }
  }

  function initFooterObserver() {
    var footer = document.querySelector('footer.footer');
    if (!footer) return;
    new IntersectionObserver(function(entries) {
      _footerVisible = entries[0].intersectionRatio >= 0.4;
      if (_footerVisible) {
        setBodySticky(false);
      } else if (_trigger && _trigger.getBoundingClientRect().bottom < 0) {
        // Footer left viewport AND ATC buttons are above viewport — re-show sticky
        setBodySticky(true);
      }
    }, { threshold: [0, 0.4] }).observe(footer);
  }

  function tryObserve(trigger) {
    if (!trigger) return false;
    _trigger = trigger;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        setBodySticky(!entry.isIntersecting);
      });
    }, { threshold: 0 });
    observer.observe(trigger);
    // Set initial state
    setBodySticky(trigger.getBoundingClientRect().bottom < 0 || trigger.getBoundingClientRect().top > window.innerHeight);
    return true;
  }

  function getTrigger() {
    return document.querySelector(
      '.product-form__buttons, .product-form__submit, .product-form, .product__column-sticky, .product-form--sticky, .product-form-sticky, .product-sticky-footer'
    );
  }

  function init() {
    var trigger = getTrigger();
    if (tryObserve(trigger)) return;

    var attempts = 0;
    var retry = setInterval(function () {
      attempts += 1;
      trigger = getTrigger();
      if (tryObserve(trigger) || attempts >= 10) {
        clearInterval(retry);
        if (!trigger) {
          // Fallback scrolling behavior in case the expected trigger class doesn't exist
          window.addEventListener('scroll', function () {
            var windowBottom = window.pageYOffset + window.innerHeight;
            var pageHeight = document.documentElement.scrollHeight;
            setBodySticky(windowBottom < pageHeight - 330);
          }, { passive: true });
        }
      }
    }, 200);
  }

  function isSoldOutFromVariant(variant) {
    // Prefer the authoritative variant.available from the variant:change event
    if (variant && typeof variant.available !== 'undefined') {
      return !variant.available;
    }
    // Fallback for initial page load (no event data): check DOM
    var registerBtn = document.querySelector('.notice-register-btn');
    if (registerBtn) return true; // register btn only renders when sold out
    var realBtn = document.querySelector('.product-form__submit');
    if (realBtn && (realBtn.disabled || realBtn.getAttribute('aria-disabled') === 'true')) return true;
    return false;
  }

  var soldOutCtaText = (function () {
    var el = document.querySelector('[data-soldout-cta]');
    return (el && el.getAttribute('data-soldout-cta')) || 'REGISTER INTEREST';
  })();

  function applyStickyNotifyMe(btn, soldOut) {
    if (soldOut) {
      btn.textContent = soldOutCtaText;
      btn.setAttribute('data-action', 'open-waitlist');
      btn.disabled = false;
      btn.style.opacity = '';
      btn.style.cursor = '';
    } else {
      btn.removeAttribute('data-action');
      btn.disabled = false;
      btn.style.opacity = '';
      btn.style.cursor = '';
    }
  }

  function syncStickyButtonState(variant) {
    var stickyBtn = document.querySelector('.desktop-sticky-add-to-cart__button');
    if (!stickyBtn) return;
    var soldOut = isSoldOutFromVariant(variant);
    if (soldOut) {
      applyStickyNotifyMe(stickyBtn, true);
    } else {
      var realBtn = document.querySelector('.product-form__submit');
      if (realBtn) {
        var realSpan = realBtn.querySelector('span:not(.sold-out-message):not(.loading__spinner)');
        if (realSpan) stickyBtn.textContent = realSpan.textContent.trim() || stickyBtn.textContent;
      } else {
        stickyBtn.textContent = 'Add to cart';
      }
      applyStickyNotifyMe(stickyBtn, false);
    }
  }

  function submitProductForm() {
    var forms = document.querySelectorAll('product-form');
    var target = null;
    for (var i = 0; i < forms.length; i++) {
      var form = forms[i].querySelector('form[data-type="add-to-cart-form"]');
      if (!form) continue;
      var idInput = form.querySelector('input[name="id"]:not([disabled])');
      if (!idInput || !idInput.value) continue;
      var submitBtn = form.querySelector('[type="submit"]');
      if (!submitBtn || submitBtn.disabled || submitBtn.getAttribute('aria-disabled') === 'true') continue;
      if (submitBtn.offsetParent !== null) { target = { form: form, btn: submitBtn }; break; }
      if (!target) target = { form: form, btn: submitBtn };
    }
    if (!target) return false;
    if (typeof target.form.requestSubmit === 'function') {
      try { target.form.requestSubmit(target.btn); return true; } catch(e) {}
    }
    target.btn.click();
    return true;
  }

  function initStickyButton() {
    var stickyBtn = document.querySelector('.desktop-sticky-add-to-cart__button');
    if (!stickyBtn) return;
    stickyBtn.addEventListener('click', function () {
      if (!stickyBtn.hasAttribute('data-action')) {
        submitProductForm();
      }
    });
    syncStickyButtonState(null);
    document.addEventListener('variant:change', function(e) {
      syncStickyButtonState(e.detail && e.detail.variant);
    });
  }

  function syncMobileStickyButton(variant) {
    var mobileBtn = document.querySelector('.mobile-sticky-add-to-cart__button');
    if (!mobileBtn) return;
    var soldOut = isSoldOutFromVariant(variant);
    if (soldOut) {
      applyStickyNotifyMe(mobileBtn, true);
    } else {
      var realBtn = document.querySelector('.product-form__submit');
      if (realBtn) {
        var realSpan = realBtn.querySelector('span:not(.sold-out-message):not(.loading__spinner)');
        if (realSpan) mobileBtn.textContent = realSpan.textContent.trim() || mobileBtn.textContent;
      } else {
        mobileBtn.textContent = 'Add to cart';
      }
      applyStickyNotifyMe(mobileBtn, false);
    }
  }

  function initMobileStickyButton() {
    var mobileBtn = document.querySelector('.mobile-sticky-add-to-cart__button');
    if (!mobileBtn) return;
    mobileBtn.addEventListener('click', function() {
      if (!mobileBtn.hasAttribute('data-action')) {
        submitProductForm();
      }
    });
    syncMobileStickyButton(null);
    document.addEventListener('variant:change', function(e) {
      syncMobileStickyButton(e.detail && e.detail.variant);
    });
  }

  /* ── Hide the sticky ATC while the cart drawer is open ──
     Observes Dawn's <cart-drawer> `.active` class, which open() adds and
     close() removes. Because every open path funnels through those methods
     (cart-icon click, AJAX add-to-cart -> renderContents() -> open(), or a
     programmatic .open()), this fires for ALL triggers. It edits no Dawn core
     JS, so it survives theme updates. */
  function initCartDrawerSync() {
    function getBars() {
      return [
        document.querySelector('.desktop-sticky-add-to-cart'),
        document.querySelector('.mobile-sticky-add-to-cart')
      ].filter(Boolean);
    }
    function apply(isOpen) {
      document.body.classList.toggle('cart-drawer-open', isOpen);
      // `inert` pulls the hidden bar out of the tab order + a11y tree.
      // The drawer's own focus trap is the baseline; this is belt-and-suspenders.
      getBars().forEach(function (bar) {
        if ('inert' in bar) bar.inert = isOpen;
      });
    }
    function watch(drawer) {
      if (!drawer) return false;
      apply(drawer.classList.contains('active'));
      new MutationObserver(function () {
        apply(drawer.classList.contains('active'));
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
      return true;
    }
    if (watch(document.querySelector('cart-drawer'))) return;
    // <cart-drawer> lives in the layout; retry briefly in case our script runs first.
    var attempts = 0;
    var retry = setInterval(function () {
      attempts++;
      if (watch(document.querySelector('cart-drawer')) || attempts >= 10) {
        clearInterval(retry);
      }
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); initStickyButton(); initFooterObserver(); initMobileStickyButton(); initCartDrawerSync(); });
  } else {
    init();
    initStickyButton();
    initFooterObserver();
    initMobileStickyButton();
    initCartDrawerSync();
  }

})();
